'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$() {
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMake$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMakebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_make$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_makebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodec$lzy2 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodecbitmap$2 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodec$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodecbitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertible$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertiblebitmap$1 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Typebitmap$1 = false;
}
export { $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ as $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ };
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.constructor = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$;
/** @constructor */
function $h_Lapp_data_types\uff3fpharmacy$package$PharmacyId$() {
}
export { $h_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ as $h_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ };
$h_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype;
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMakebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_defaultMake$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_makebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_makebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_make$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Typebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Type$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_utils_NewtypeULID$$anon$1(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Show_Type$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.given_CanEqual1_Type__s_CanEqual = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Typebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_CanEqual1_Type$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.given_Ordering_Type__s_math_Ordering = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Typebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NewtypeULID__given_Ordering_Type__s_math_Ordering(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Ordering_Type$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.given_Order_Type__Lcats_kernel_Order = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Typebitmap$1)) {
    var ev = this.given_Ordering_Type__s_math_Ordering();
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Type$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_kernel_Order$$anon$9(ev);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Order_Type$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodecbitmap$2)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodec$lzy2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodecbitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_circeCodec$lzy2;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.tapirCodec__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodecbitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodec$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodecbitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_tapirCodec$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.urlConvertible__Lframework_utils_UrlConvertible = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertiblebitmap$1)) {
    var codec = this.tapirCodec__Lsttp_tapir_Codec();
    var errorFromThrowable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsFromThrowable__Lurldsl_errors_ErrorFromThrowable();
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertible$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_utils_UrlConvertible$fromCodec(codec, errorFromThrowable);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertiblebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_urlConvertible$lzy1;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$.prototype.given_Schema_Type__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Typebitmap$1)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Type$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_Base64Id$().schemaFor__Lsttp_tapir_Schema();
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyId$__f_given_Schema_Type$lzy1;
});
var $d_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$, "app.data.types_pharmacy$package$PharmacyId$", ({
  Lapp_data_types\uff3fpharmacy$package$PharmacyId$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeULID: 1
}));
export { $d_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ as $d_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ };
var $n_Lapp_data_types\uff3fpharmacy$package$PharmacyId$;
function $m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$() {
  if ((!$n_Lapp_data_types\uff3fpharmacy$package$PharmacyId$)) {
    $n_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ = new $c_Lapp_data_types\uff3fpharmacy$package$PharmacyId$();
  }
  return $n_Lapp_data_types\uff3fpharmacy$package$PharmacyId$;
}
export { $m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ as $m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$ };
//# sourceMappingURL=app.data.types_pharmacy$package$-Pharmacy-Id$.js.map
